"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Measure = void 0;
var genericMeasureFactory_1 = require("./genericMeasureFactory");
var genericMeasureUtils_1 = require("./genericMeasureUtils");
var staticMethods = {
    abs: (0, genericMeasureUtils_1.wrapUnaryFn)(Math.abs),
    ceil: (0, genericMeasureUtils_1.wrapUnaryFn)(Math.ceil),
    floor: (0, genericMeasureUtils_1.wrapUnaryFn)(Math.floor),
    fround: (0, genericMeasureUtils_1.wrapUnaryFn)(Math.fround),
    round: (0, genericMeasureUtils_1.wrapUnaryFn)(Math.round),
    trunc: (0, genericMeasureUtils_1.wrapUnaryFn)(Math.trunc),
    hypot: (0, genericMeasureUtils_1.wrapSpreadFn)(Math.hypot),
};
var numericOps = {
    one: function () { return 1; },
    neg: function (x) { return -x; },
    add: function (x, y) { return x + y; },
    sub: function (x, y) { return x - y; },
    mult: function (x, y) { return x * y; },
    div: function (x, y) { return x / y; },
    reciprocal: function (x) { return 1 / x; },
    compare: function (x, y) { return x - y; },
    format: function (x) { return "".concat(x); },
};
exports.Measure = (0, genericMeasureFactory_1.createMeasureType)(numericOps, staticMethods);
//# sourceMappingURL=numberMeasure.js.map